export const SANDBOX_BOTTOM_EDGE_OFFSET = 40;
export const SANDBOX_DEFAULT_Y = 80;
export const SANDBOX_RIGHT_EDGE_OFFSET = 100;
export const SANDBOX_SIZE_LIMITS = {
    maxHeight: 1100,
    maxWidth: 1400,
    minHeight: 360,
    minWidth: 380
} as const;

export const SANDBOX_VIEWPORT_PADDING = 8;
